import React from 'react';
import { FieldValues } from 'react-hook-form';

import { QuestionSelectProps } from '../types';
import { QuestionSize } from '../constants';
import QuestionTemplate from '.';
import Select from 'components/Inputs/Select';

function QuestionSelect<T extends FieldValues>({
  children,
  control,
  disabled,
  id,
  label,
  name,
  readOnly,
  size = QuestionSize.MEDIUM,
  ...props
}: QuestionSelectProps<T>) {
  return (
    <QuestionTemplate<T>
      control={control}
      disabled={disabled}
      id={id}
      label={label}
      name={name}
      readOnly={readOnly}
      size={size}>
      {({ invalid, onBlur, onChange, ref, value }) => (
        <Select
          disabled={disabled}
          id={id}
          inputRef={ref}
          invalid={invalid}
          name={name}
          onBlur={onBlur}
          onChange={onChange}
          readOnly={readOnly}
          size={size}
          value={value as string}
          {...props}>
          {children}
        </Select>
      )}
    </QuestionTemplate>
  );
}

export default React.memo(QuestionSelect) as typeof QuestionSelect;
